import { FolderCard } from "./FolderCard";
import { useFolderNavigation } from "./useFolderNavigation";
import { Button, Input, Col, Empty, Card, Row, message } from "antd";
import { ArrowLeftOutlined, ReloadOutlined } from "@ant-design/icons";
import { FolderBreadcrumb } from "./FolderBreadcrumb";
import { useState, useEffect, useCallback, useRef } from "react";

const { Search } = Input;

export function FolderNavigator({ 
  codigo_tarea,
  filtro,
  data, 
  className, 
  onRefresh, 
  onInvalidateCache, 
  onNavigationChange,
  preservedNavigationState // 👈 Nuevo prop para estado preservado
}) {
  // Usar useRef para mantener una referencia al estado de navegación inicial
  const initialNavigationState = useRef(preservedNavigationState || null);
  
  const {
    navigationState,
    filteredItems,
    searchFilter,
    setSearchFilter,
    navigateToFolder,
    navigateBack,
    navigateToBreadcrumb,
    canNavigateBack,
    updateFileCount,
    updateData,
    rootData,
  } = useFolderNavigation(data, initialNavigationState.current);

  // Efecto para actualizar datos cuando cambian
  useEffect(() => {
    if (data && JSON.stringify(data) !== JSON.stringify(rootData)) {
      updateData(data);
    } 
  }, [data, rootData, updateData]);

  // Efecto para notificar cambios de navegación
  useEffect(() => {
    if (onNavigationChange) {
      onNavigationChange(navigationState);
    }
  }, [navigationState, onNavigationChange]);




  const handleFileUpload = useCallback(async (file, folderPath) => {
    try {
      if (onInvalidateCache) {
        await onInvalidateCache(folderPath);
      }
      
      await new Promise(resolve => setTimeout(resolve, 500));
      
      if (onRefresh) {
        await onRefresh();
      }
      
    } catch (error) {
      console.error('❌ Error al subir archivo:', error);
      message.error('Error al subir el archivo');
    }
  }, [onInvalidateCache, onRefresh]);

  const handleRefresh = useCallback(() => {
    if (onRefresh) {
      onRefresh();
    }
  }, [onRefresh]);

  return (
    <div className={className} style={{ padding: "4px" }}>
      {/* Header */}
      <Row gutter={24} style={{ marginBottom: 16 }}>
        <Col span={24}>
          <FolderBreadcrumb
            breadcrumbs={navigationState.breadcrumbs}
            onNavigate={navigateToBreadcrumb}
          />
        </Col>
      </Row>
      
      {/* Search */}
      <Row gutter={16} style={{ marginBottom: 16 }}>
        <Col span={16}>
          <Search
            placeholder="Buscar carpetas o archivos"
            value={searchFilter}
            onChange={(e) => setSearchFilter(e.target.value)}
            allowClear
          />
        </Col>
      
        <Col span={8} style={{ textAlign: "right" }}>
          <Button
            type="default"
            icon={<ReloadOutlined />}
            onClick={handleRefresh}
            style={{ marginRight: 8 }}
          >
            Actualizar Contenedor
          </Button>

          {canNavigateBack && (
            <Button
              type="default"
              icon={<ArrowLeftOutlined />}
              onClick={navigateBack}
            >
              Volver
            </Button>
          )}
        </Col>
      </Row>
      
      <Row gutter={24} style={{ marginBottom: 16 }}>
        <Col span={24}>
          {filteredItems.length > 0 ? (
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                gap: "16px",
              }}
            >
              {filteredItems.map((item) => (
                <Card
                  key={item.key}
                  hoverable
                  styles={{ body: { padding: 12 } }}
                  style={{ height: "100%" }}
                >
                  <FolderCard
                    codigo_tarea={codigo_tarea}
                    filtro={filtro}
                    item={item}
                    onClick={navigateToFolder}
                    isNavigable={true}
                    onUpdateFileCount={updateFileCount}
                    onFileUpload={handleFileUpload}
                    onRefresh={onRefresh}
                  />
                </Card>
              ))}
            </div>
          ) : (
            <Empty
              description={
                searchFilter
                  ? "No se encontraron resultados"
                  : "No hay elementos para mostrar"
              }
              style={{ padding: 48 }}
            />
          )}
        </Col>
      </Row>
    </div>
  );
}